import { Component } from 'preact'
import $ from 'jquery'
import selectize from 'selectize' // eslint-disable-line no-unused-vars

export default class CategorySelector extends Component {
  componentDidMount () {
    const onMount = true
    this.initSelect(onMount)
  }

  componentDidUpdate () {
    this.initSelect()
  }

  initSelect (onMount = false) {
    const { keyToUpdate, onUpdate } = this.props

    $('select.qa-category-select').selectize({
      onInitialize: function () {
        if (!onMount) {
          this.clear()
        }
      },
      onChange: categoryId => onUpdate(keyToUpdate, categoryId)
    })
  }

  render (props, state) {
    const { categories, selectedCategoryId } = props

    return (
      <select placeholder='Choose a category' class='qa-category-select'>
        <option value='' />
        {
          categories.map((categoryGroup) =>
            <optgroup label={categoryGroup.groupName}>
              {
                categoryGroup.categories
                  ? categoryGroup.categories.map((subCategory) => {
                    return <option {...(selectedCategoryId === subCategory.categoryId && { selected: true })} value={subCategory.categoryId}>
                      {subCategory.categoryName}
                    </option>
                  }
                  )
                  : null
              }
            </optgroup>
          )
        }
      </select>
    )
  }
}
